export default __webpack_public_path__ + "static/media/pershing.0a66c954.jpg";